export type ExtraLongWordsTooltipState = {
  top: number
  left: number
  title: string
}

type Props = {
  tooltip: ExtraLongWordsTooltipState | null
}

/**
 * Cursor-positioned floating tooltip that replaces the legacy `ui_kit_qmd`
 * `FullTextPositionToolTip` (an absolutely-positioned `EllipsisTextPopup`). The DS `Tooltip`
 * is a hover/click-trigger wrapper with an incompatible API — it cannot render a tooltip whose
 * `{ top, left }` come from cursor coordinates in state — so the original markup is preserved
 * here with the former `.fullMemberNameTooltip` / `.ellipsis-text-popup` SCSS converted to
 * Tailwind + DS tokens. `top`/`left` stay inline because they are genuinely dynamic.
 */
export function ExtraLongWordsTooltip({ tooltip }: Props) {
  if (!tooltip) return null

  return (
    <div
      className='absolute z-[9999] w-4/5 cursor-default whitespace-pre-wrap break-all rounded-md bg-surface-active px-[10px] py-[5px] text-center text-text-dark'
      style={{ top: tooltip.top, left: tooltip.left }}>
      {tooltip.title}
    </div>
  )
}
